export type RendererMode = 'WEBGL' | 'CANVAS';
export const resolveRendererMode = (visualRegressionMode: boolean): RendererMode => visualRegressionMode ? 'CANVAS' : 'WEBGL';
export const readVisualRegressionMode = (search: string): boolean => new URLSearchParams(search).get('visualRegressionMode') === 'true';
